/* ==========================================================================
   ODYSSÉE ACADEMY : comportements de base
   Menu burger, sous-menus en accordéon, mesure de la navbar.
   ========================================================================== */

(function () {
  'use strict';

  var DESKTOP = '(min-width: 992px)';

  /* --- Hauteur réelle de la navbar (+ topbar si présente) ----------------- */

  function measureNav() {
    var navbar = document.querySelector('[data-navbar]');
    var topbar = document.querySelector('[data-topbar]');
    var topbarH = topbar ? topbar.offsetHeight : 0;
    document.documentElement.style.setProperty('--oda-topbar-h', topbarH + 'px');
    if (!navbar) return;
    document.documentElement.style.setProperty('--oda-nav-h', (navbar.offsetHeight + topbarH) + 'px');
  }

  /* --- Menu burger -------------------------------------------------------- */

  function initBurger() {
    var burger = document.querySelector('.nav-burger');
    var menu = document.getElementById('nav-menu');
    if (!burger || !menu) return;

    var close = menu.querySelector('.nav-menu-close');

    function closeSubs() {
      menu.querySelectorAll('.nav-dropdown-toggle.is-open').forEach(function (t) {
        t.classList.remove('is-open');
        var link = t.querySelector('.nav-link');
        if (link) link.setAttribute('aria-expanded', 'false');
      });
    }

    function setOpen(open) {
      menu.classList.toggle('is-open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.classList.toggle('nav-open', open);
      if (!open) closeSubs();
    }

    function toggle() { setOpen(!menu.classList.contains('is-open')); }

    burger.addEventListener('click', toggle);
    burger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
    });

    if (close) {
      close.addEventListener('click', function () { setOpen(false); });
      close.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setOpen(false); }
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) setOpen(false);
    });

    /* Tiroir mobile (01/09) : clic sur le voile (hors panneau et hors burger) = fermeture. */
    document.addEventListener('click', function (e) {
      if (!menu.classList.contains('is-open')) return;
      if (menu.contains(e.target) || burger.contains(e.target)) return;
      setOpen(false);
    });

    /* Un lien de navigation ferme le panneau. */
    menu.addEventListener('click', function (e) {
      var link = e.target.closest('.nav-link, .nav-sublink');
      if (!link) return;
      /* Sous 992 px, le libellé d'un menu déroulant ouvre son accordéon
         au lieu de naviguer : sinon les sous-pages seraient inatteignables.
         Un toggle data-mega (« s'entraîner »/« boutique ») gère lui-même son
         état .is-open en desktop via assets/header-mega.js : on ne doit pas
         le lui reprendre ici (setOpen(false) → closeSubs() l'aurait effacé
         dans la même passe de clic, juste après son ouverture). */
      var toggleEl = link.closest('.nav-dropdown-toggle');
      if (toggleEl && link.classList.contains('nav-link') &&
          (!window.matchMedia(DESKTOP).matches || toggleEl.hasAttribute('data-mega'))) return;
      setOpen(false);
    });

    window.addEventListener('resize', function () {
      if (window.matchMedia(DESKTOP).matches && menu.classList.contains('is-open')) setOpen(false);
    });
  }

  /* --- Sous-menus en accordéon (sous 992 px) ------------------------------ */

  function initSubmenus() {
    var toggles = document.querySelectorAll('.nav-dropdown-toggle[data-nav-toggle]');
    if (!toggles.length) return;

    toggles.forEach(function (toggle) {
      var link = toggle.querySelector('.nav-link');
      var caret = toggle.querySelector('.nav-caret');

      function openSub(e) {
        if (window.matchMedia(DESKTOP).matches) return;
        e.preventDefault();
        var wasOpen = toggle.classList.contains('is-open');
        toggles.forEach(function (t) {
          t.classList.remove('is-open');
          var l = t.querySelector('.nav-link');
          if (l) l.setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) {
          toggle.classList.add('is-open');
          if (link) link.setAttribute('aria-expanded', 'true');
        }
      }

      if (link) {
        link.addEventListener('click', openSub);
        link.addEventListener('keydown', function (e) {
          if ((e.key === 'Enter' || e.key === ' ') && !window.matchMedia(DESKTOP).matches) openSub(e);
        });
      }
      if (caret) caret.addEventListener('click', openSub);
    });
  }

  /* --- Vidéo de fond : Safari retire muted et loop à la publication ------- */

  function guardVideos() {
    document.querySelectorAll('.hero-background-video').forEach(function (v) {
      if (!(v instanceof HTMLVideoElement)) return;
      v.muted = true;
      v.defaultMuted = true;
      v.loop = true;
      v.playsInline = true;
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    });
  }

  /* --- Accordéons mobiles partagés (chantier responsive étape 4, 05/09) --- */
  /* snippets/oda-mobile-accordion.liquid. Délégué sur document : survit à
     shopify:section:load sans réinitialisation, et ne coûte rien sur les
     pages qui n'en contiennent aucun. */

  function initMobileAccordions() {
    if (window.__odaMAccBound) return;
    window.__odaMAccBound = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.oda-m-acc-btn');
      if (!btn) return;
      var wrap = btn.parentElement;
      if (wrap && wrap.getAttribute('data-desktop') === 'always'
          && window.matchMedia('(min-width: 768px)').matches) return;
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      var lbl = btn.querySelector('.oda-m-acc-label');
      var next = btn.getAttribute(open ? 'data-label-closed' : 'data-label-open');
      if (lbl && next) lbl.textContent = next;
    });
  }

  /* Cohérence ARIA au-dessus de 767 px : le panneau y est déroulé par le CSS,
     l'attribut doit dire la même chose. Appelée à l'init et au resize. */
  function syncMobileAccordions() {
    var big = window.matchMedia('(min-width: 768px)').matches;
    document.querySelectorAll('.oda-m-acc[data-desktop="always"] > .oda-m-acc-btn')
      .forEach(function (b) { if (big) b.setAttribute('aria-expanded', 'true'); });
  }

  /* --- CTA "chronomètre" (snippets/oda-cta-chrono.liquid, retour Murat ---- */
  /* 05/09, 17e série pt 89) : cadran + décompte scroll-driven, VERBATIM du
     comportement d'origine (page-préparation-physique) : ce n'est pas un
     vrai chronomètre temps réel, la progression suit le scroll dans la
     section. Une instance par page (au plus une .section-countdown par
     page actuellement, boucle générique pour rester correct si ça change). */

  function initCountdownSections() {
    document.querySelectorAll('.section-countdown').forEach(function (sec) {
      if (sec.dataset.odaCountdownInit === '1') return;
      sec.dataset.odaCountdownInit = '1';
      var dial = sec.querySelector('.countdown-dial'), out = sec.querySelector('.countdown-time');
      if (!dial || !out) return;
      var TOTAL = 300, last = -1, queued = false;
      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      function render() {
        queued = false;
        var r = sec.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var start = vh, end = Math.max(0, vh - r.height), span = start - end;
        var p = span <= 0 ? 1 : (start - r.top) / span;
        if (p < 0) p = 0; if (p > 1) p = 1;
        dial.style.setProperty('--cd-p', p.toFixed(4));
        var left = Math.round(TOTAL * (1 - p));
        if (left !== last) {
          last = left;
          out.textContent = pad(Math.floor(left / 3600)) + ':' + pad(Math.floor(left / 60) % 60) + ':' + pad(left % 60);
        }
        if (p >= 0.999) { sec.classList.add('is-complete'); } else { sec.classList.remove('is-complete'); }
      }
      function schedule() { if (!queued) { queued = true; requestAnimationFrame(render); } }
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
      render();
    });
  }

  function init() {
    measureNav();
    initBurger();
    initSubmenus();
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) guardVideos();
    initMobileAccordions();
    syncMobileAccordions();
    initCountdownSections();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', measureNav);
  window.addEventListener('resize', measureNav);
  window.addEventListener('resize', syncMobileAccordions);

  /* L'éditeur de thème recharge les sections sans recharger la page. */
  document.addEventListener('shopify:section:load', init);
})();
